import { Component } from '@angular/core';
import { FooterConstants } from '../../app-core/constants/common-constants';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrl: './footer.component.scss'
})
export class FooterComponent {
	footerConstants: typeof FooterConstants = FooterConstants;
}
